import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Title.less';

export default function Title({
  isMobile,
  list,
  name,
  apiKeyName,
  handleDropDownClick,
  isRowExpanded,
  selectedSortValue,
  sortSection,
  filters,
}) {
  const userHints = sortSection
    ? list
        .filter(({ value }) => value === selectedSortValue)
        .map((el) => el.title)
        .join('')
    : list
        .filter(({ value }) => Boolean(filters && filters[value]))
        .map((el) => el.label)
        .join(', ');
  const classNameCategory = classNames('category-title', {
    'is-open': isRowExpanded,
  });
  const classNameChevron = classNames(
    'zola-ui',
    isRowExpanded ? 'zola-ui-icon-chevron-up' : 'zola-ui-icon-chevron-down'
  );

  return (
    <div className="title-row" onClick={() => handleDropDownClick(apiKeyName)}>
      <i className={classNameChevron} />
      <span className={classNameCategory}>
        {name}
        {isMobile && !isRowExpanded && userHints && (
          <span id="js-hint-container" className="sort-hint">
            {userHints}
          </span>
        )}
      </span>
    </div>
  );
}

Title.propTypes = {
  name: PropTypes.string,
  apiKeyName: PropTypes.string,
  selectedSortValue: PropTypes.string,
  handleDropDownClick: PropTypes.func,
  isRowExpanded: PropTypes.bool,
  isMobile: PropTypes.bool,
  sortSection: PropTypes.bool,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      title: PropTypes.string,
      label: PropTypes.string,
    })
  ),
  filters: PropTypes.shape({}),
};
